import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_legacy/dashboards')({
  beforeLoad: () => {
    throw redirect({ to: '/', replace: true })
  },
})
